fx.ns("shared.popups", class ConversionPdfFiles extends fx.components.Popup{
    
    constructor(data)
    {
        super(data);

        this.service = fx.service("PdfUploader");

        this.contentWidth = 600;
        this.contentHeight = 240;

        this.destroyOnSwitch = true;
    }

    create()
    {
        super.create();
        
        let vbox = new fx.components.VBox();

        // title
        vbox.addChild(new fx.components.Text({text:fx.text("Votre fichier est en cours d'import..."), className:"title center"}), {left:0, top:20, width:"100%"});

        // progress bar
        this.progressBar = new fx.components.ProgressBar({showLabel:true});
        vbox.addChild(this.progressBar, {width:"100%", height:50, top:50});
        
        // button
        this.cancelButton = new fx.components.Button({label : fx.text("Annuler")});
        vbox.addChild(this.cancelButton, {left : "center", top:75, width:150});

        this.addChild( vbox, {top:0, left:0, width:"100%", height:"100%"});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onCancel, this.cancelButton);

        this.progressBar.update(this.service.position, this.service.total);
    }

    onCancel()
    {
        this.service.abortUploading();

        this.close();
    }

    destroy()
    {
        super.destroy();
    }

    /******************************** Events *****************************/

    onDataEvent(event)
	{
        super.onDataEvent(event);
        
        if (event.type === "file-uploaded")
            this.close();
        else
        if (event.type === "file-upload-failed")
            this.close();
        else
        if (event.type == "file-upload-progress")
            this.progressBar.update(this.service.position, this.service.total);
    }

    onClick(e)
    {
        e.preventDefault();
    }

});